import { useTranslation } from "react-i18next";
import { SideButtons } from "./sideButtons";
import { useEffect, useRef, useState } from "react";

import plans from '../icons/plans.png';
import unit from '../icons/unit.png';
import visit from '../icons/360.png';
import contact from '../icons/contact.png';
import CustomAccordion from "./accordion";

export const Menu = ({ current, setCurrent, changeVirtualScene, tmpFloorUnit, setFloorUnit, setCurrLvl }) => {
    const { i18n, t } = useTranslation();
    const contactLink = i18n.language === "fr" ? "https://liria.ca/projets/blainville/#form" : "https://liria.ca/en/projects/blainville/#form";

    const contentRef = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);
    const clickMenu = (main, sub) => {
        setCurrent({ main, sub });
        changeVirtualScene(sub);
    }

    useEffect(() => {
        const checkScroll = () => {
            const el = contentRef.current;

            if (!el) return;

            setHasScroll(el.scrollHeight > el.clientHeight);
        };

        checkScroll();

        window.addEventListener("resize", checkScroll);

        return () => {
            window.removeEventListener("resize", checkScroll);
        };
    }, [current]);

    return (
        <div className="flex flex-col h-full overflow-y-auto justify-between items-end">
            <div className="w-full">
                <img className="p-[20px] lg:p-10 w-auto h-[80px] lg:pb-0 pb-0 sm:h-auto sm:w-full mx-auto" src="./images/logo.png" />

                {/* <div className="flex-1 h-[1px] bg-[var(--gold)] mb-[20px] my-[20px] mx-[20px] lg:mx-10"></div> */}
                <div className="flex-1 h-[1px] mb-[20px] my-[20px]"></div>
                
                <SideButtons reclick icon={plans} onClick={() => { clickMenu("plans", "floor"); setCurrLvl(0); }} id="plans" current={current} isFirst text={t("plansSelector")} />

                {current?.sub === "floor" ?
                    <SideButtons icon={unit} id="floor" current={current} second text={t("chooseFloor")} /> :
                    current?.sub === "unit" ?
                        <SideButtons icon={unit} id="unit" current={current} second text={t("chooseUnit")} /> :
                        <></>
                }
                <SideButtons icon={visit} onClick={() => { clickMenu("visit", "lobby02"); setFloorUnit(current.sub) }} id="visit" current={current} text={t("virtualVisit")} />
                {/* Sous menu visite virtuelle */}

                {(current?.sub !== "floor" && current?.sub !== "unit") &&
                    <>
                        <CustomAccordion defaultOpen={true} title={t("commonSpace")}>
                            <SideButtons second onClick={() => clickMenu("visit", "lobby02")} id="lobby02" current={current} text={t("vHall")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "coworking")} id="coworking" current={current} text={t("vCoworking")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "gym01")} id="gym01" current={current} text={t("vGym")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "suite02")} id="suite02" current={current} text={t("vLounge")} small />
                            <SideButtons second onClick={() => clickMenu("visit", "pool")} id="pool" current={current} text={t("vPool")} small />
                        </CustomAccordion>
                        {/* Unité type */}
                        <CustomAccordion title={t("uniteTypePL")}>
                            <SideButtons forceActiveCode="p_" second onClick={() => clickMenu("visit", "p_dining")} id="p_dining" current={current} text={t("vPenthouse")} small />
                            <SideButtons forceActiveCode="ua_" second onClick={() => clickMenu("visit", "ua_kitchen")} id="ua_kitchen" current={current} text={t("vUnitA")} small />
                            <SideButtons forceActiveCode="ub_" second onClick={() => clickMenu("visit", "ub_salon")} id="ub_salon" current={current} text={t("vUnitB")} small />
                        </CustomAccordion>
                        <div className="w-full h-[1px] bg-[var(--gold)]"></div>
                    </>
                }

                <SideButtons icon={contact} onClick={() => window.open(contactLink, '_blank')} id="contact" current={current} text={t("contact")} />
            </div>
            {/* Logo Edge */}
            <img
                onClick={() => window.open('https://www.edgedimension.com/' + i18n.language, '_blank')}
                className={`z-[10] my-[10px] mr-[10px] p-2 rounded transition-all w-[75px] hover:opacity-100 opacity-50 cursor-pointer`}
                src={`./images/logo-edge_${i18n.language}.png`}
            />
        </div>
    )
}